// @flow

export function isPostalCode(value?: ?string) {
  return typeof value === "string" && /^[0-9]{5}$/.test(value);
}
